import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tc-svg-arrow-top",
  "use": "tc-svg-arrow-top-usage",
  "viewBox": "0 0 9 16",
  "content": "<symbol viewBox=\"0 0 9 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tc-svg-arrow-top\">\n<path d=\"M1 0.5L8.12329 8L1 15.5\" stroke=\"#17120E\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol